import { newAPI } from "../newAxios";

// add new advance API function
export const addNewAdvanceAPI = async (advanceData) => {
    const response = await newAPI.post("/employeeAdvanceSalary/add", advanceData);
    return response.data;
}

// API call function for fetching advance data
export const fetchAdvanceDataAPI = async (params = {}) => {
    const {
        pageIndex = 1,
        pageSize = 10,
        employee_name = '',
        date_of_advance = '',
        status = '',
        recoverey_status = '',
    } = params;

    try {
        const response = await newAPI.post(
            '/employeeAdvanceSalary/filters',
            {
                pageIndex,
                pageSize,
                employee_name,
                date_of_advance,
                status,
                recoverey_status,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};


// API call function for edit advance data by ID
export const fetchAdvanceByIdAPI = async (advanceId) => {
    try {
        const response = await newAPI.get(`/employeeAdvanceSalary/${advanceId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};


// API call function for updating advance data
export const updateAdvanceAPI = async (advanceData) => {
    try {
        const response = await newAPI.post(`/employeeAdvanceSalary/add`, advanceData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// API call function for deleting advance data
export const deleteAdvanceAPI = async (advanceId) => {
    try {
        const response = await newAPI.delete(`/employeeAdvanceSalary/${advanceId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};


// API call for filtering advance data
export const fetchAdvanceDataByFilterAPI = async (filterParams = {}) => {
    try {
        const {
            pageSize = 10,
            pageIndex = 1,
            employee_name = '',
            status = '',
            date_of_advance = '',
            recoverey_status = '',
        } = filterParams;
        const response = await newAPI.post(
            '/employeeAdvanceSalary/filters',
            {
                pageSize,
                pageIndex,
                employee_name,
                date_of_advance,
                status,
                recoverey_status,
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

